<template>
  <component :is="type" v-bind="properties">
    <slot />
  </component>
</template>

<script>
/**
 * Un composant qui affiche un <router-link :to="{ name: '', params: {} }"></router-link> ou un span en fonction thes droits de navigation
 */
export default {
  props: {
    to: {
      type: Object,
      required: true,
    },
  },
  computed: {
    navigable() {
      return this.$auth.mayNavigateTo(this.to);
    },
    type() {
      return this.navigable ? 'router-link' : 'span';
    },
    properties() {
      return this.navigable ? { to: this.to } : {};
    },
  },
};
</script>
